/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Slots_Display_Add_BeforeInputs */

const en_time_slots_display_add_before = /** @type {(inputs: Time_Slots_Display_Add_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another slot before`)
};

const de_time_slots_display_add_before = /** @type {(inputs: Time_Slots_Display_Add_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weiteren Slot davor hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add another slot before" |
*
* @param {Time_Slots_Display_Add_BeforeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_slots_display_add_before = /** @type {((inputs?: Time_Slots_Display_Add_BeforeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Slots_Display_Add_BeforeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_slots_display_add_before(inputs)
	return en_time_slots_display_add_before(inputs)
});